import useGetNewsTipNewspaper from './useGetNewsTipNewspaper'

export default useGetNewsTipNewspaper
